import { atom } from 'infrastructure/state/jotai.wrapper'

export const selectedAttributionAtom = atom('IM')
